// React, Next
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'
import BulletGrid from '@/components/sections/BulletGrid'

// Style
import themeColors from 'assets/theme/colors'

export default function ScalingSection() {
  const { t } = useTranslation('solutionsIotAirQualityMonitoring')

  const items = [
    t('scaling.items.01'),
    t('scaling.items.02'),
    t('scaling.items.03'),
    t('scaling.items.04'),
    t('scaling.items.05'),
    t('scaling.items.06')
  ]

  const getContent = () => (
    <Box sx={{ width: '100%' }}>
      <SectionHeader
        eyebrow={t('scaling.eyebrow')}
        title={t('scaling.title')}
        intro={[t('scaling.intro1'), t('scaling.intro2'), t('scaling.intro3')]}
      />

      <BulletGrid items={items} columns={3} />
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.section.light}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
